<div class="sidebar-shop" [ngClass]="toggle ? 'sidebar-filter' : 'sidebar'">
    <div [class.sidebar-filter-wrapper]="toggle">
        <div class="widget widget-clean">
            <label>Filters:</label>
            <a [routerLink]="" class="sidebar-filter-clear">Clean All</a>
        </div>

        <div class="widget widget-collapsible">
            <h3 class="widget-title mb-2">
                <a data-toggle="collapse" href="#widget-1" role="button" aria-expanded="true" aria-controls="widget-1">
                    Categories
                </a>
            </h3>

            <div class="collapse show" id="widget-1">                
                <div class="widget-body pt-0">
                    <div class="filter-item" *ngFor="let cat of cats">
                        <a class="cat" >{{cat.PCM_Description }}</a>            
                        <ul>
                            <li *ngFor="let subcat of cat.subcategories">
                                <a routerLink="" (click)="subCatClicked(subcat)" class="subcat">{{subcat.CatDescription}}</a>                                    
                            </li>
                        </ul>                       
                    </div>
                </div>                                
            </div>
        </div>
    </div>
</div>